import { ButtonBase } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { TableColumnsFilterComponent, Tables } from '../../../../../../../../Components';
import {
  TableActions,
  FormsIdsEnum,
  ColumnsFilterPagesEnum,
  TableFilterTypesEnum,
} from '../../../../../../../../Enums';
import {
  GlobalHistory, showError, showSuccess, GetParams
} from '../../../../../../../../Helper';
import { ActiveItemActions } from '../../../../../../../../store/ActiveItem/ActiveItemActions';
import { DuplicateContactsTableHeaderData } from './DuplicateContactsTableHeaderData';
import { GetAllFormFieldsByFormId, DiscardContact, RemoveDiscardContact } from '../../../../../../../../Services';
import { TableColumnsFilterActions } from '../../../../../../../../store/TableColumnsFilter/TableColumnsFilterActions';
import { ContactsActionDialogsComponent } from '../../../../../ContactsUtilities/ContactsActionDialogsComponent/ContactsActionDialogsComponent';

export const DuplicateContactsTableComponent = ({
  filter,
  pathName,
  onRowClick,
  isOneSelect,
  checkedCards,
  setCheckedCards,
  checkedCardsIds,
  onPageSizeChanged,
  setCheckedCardsIds,
  onPageIndexChanged,
  detailsContactsList,
  activeSelectedAction,
  contactTableFilter,
  onFilterValuesChanged,
  parentTranslationPath,
  setActiveTab,
  isWithCheckboxColumn,
  reloadData,
  isDiscardChanged,
  setIsDiscardChanged
}) => {

  const { t } = useTranslation('Shared');
  const dispatch = useDispatch();
  const [allFormFields, setAllFormFields] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableColumns, setTableColumns] = useState([]);
  const [isOpenContactsActionDialog, setisOpenContactsActionDialog] = useState(false);
  const [tableFilterData, setTableFilterData] = useState([]);
  const [detailedCardAction, setdetailedCardAction] = useState(() => ({
    actionEnum: '',
    item: '',
  }));
  const [selectedTableFilterColumns, setSelectedTableFilterColumns] = useState(
    DuplicateContactsTableHeaderData.filter((item) => item.isDefaultFilterColumn).map((column) => column.id)
  );
  const tableColumnsFilterResponse = useSelector((state) => state.TableColumnsFilterReducer);
  const defaultPrefernces = [
    {
      enum: TableActions.openFile.key,
    },
    {
      enum: TableActions.editText.key,
    },
  ];
  const [activePrefernces, setActiveprefernces] = useState(defaultPrefernces);
  const tableActionClicked = useCallback(
    (actionEnum, item, focusedRow, event) => {
      event.stopPropagation();
      event.preventDefault();
      dispatch(ActiveItemActions.activeItemRequest(item));
        if (actionEnum === TableActions.openFile.key) {
        if (pathName === 'contact-sales') {
          GlobalHistory.push(
            `/home/contact-sales/contact-profile-edit?formType=${item.userTypeId}&id=${item.id}`
          );
        } else if (pathName === 'contact-lease') {
          GlobalHistory.push(
            `/home/contact-lease/contact-profile-edit?formType=${item.userTypeId}&id=${item.id}`
          );
        } else if (pathName === 'Contacts-CRM') {
          GlobalHistory.push(
            `/home/Contacts-CRM/contact-profile-edit?formType=${item.userTypeId}&id=${item.id}`
          );
        } else if (pathName === 'Contacts-CRM/contact-profile-edit') {
          setActiveTab(0);
          GlobalHistory.push(
            `/home/Contacts-CRM/contact-profile-edit?formType=${item.userTypeId}&id=${item.id}`
          );
        }
      } else if (actionEnum === TableActions.editText.key) {
        if (pathName === 'contact-sales')
          GlobalHistory.push(`/home/contact-sales/edit?formType=${item.userTypeId}&id=${item.id}`);
        else if (pathName === 'contact-lease')
          GlobalHistory.push(`/home/contact-lease/edit?formType=${item.userTypeId}&id=${item.id}`);
        else if (pathName === 'Contacts-CRM')
          GlobalHistory.push(`/home/Contacts-CRM/edit?formType=${item.userTypeId}&id=${item.id}`);
        else if (pathName === 'Contacts-CRM/contact-profile-edit') {
          GlobalHistory.push(
            `/home/Contacts-CRM/edit?formType=${item.userTypeId}&id=${item.id}`
          );
        }
      } else if (actionEnum === TableActions.discardDuplicateText.key) {
        createDiscardContact(item.id);
        setIsDiscardChanged(true)
      } else if (actionEnum === TableActions.removeDiscardText.key) {
        removeDiscardContact(item.id);
        setIsDiscardChanged(true)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, pathName]
  );
  const getIsSelected = useCallback(
    (row) => checkedCards && checkedCards.findIndex((item) => item.id === row.id) !== -1,
    [checkedCards]
  );
  const getIsDisabled = useCallback(
    (row) =>
      (isOneSelect && checkedCardsIds && checkedCardsIds.length === 10 && !getIsSelected(row)) ||
      (checkedCardsIds && checkedCardsIds.length > 10 && !getIsSelected(row)) ||
      (checkedCards && checkedCards[0] && checkedCards[0].userTypeId !== row.userTypeId),
    [checkedCards, checkedCardsIds, getIsSelected, isOneSelect]
  );
  const onSelectClicked = useCallback(
    (row) => {
      const isContactWithTransaction = row.isWithTransaction === 1 && !getIsSelected(row);
      const itemIndex = checkedCardsIds ? checkedCardsIds.findIndex((item) => item === row.id) : -1;
      if (itemIndex !== -1) {
        checkedCardsIds.splice(itemIndex, 1);
        setCheckedCards((items) => {
          const elementIndex = items.findIndex((item) => item.id === row.id);
          if (elementIndex !== -1) items.splice(elementIndex, 1);
          return [...items];
        });
      } else if (!isContactWithTransaction) {
        checkedCardsIds.push(row.id);
        setCheckedCards((items) => {
          items.push(row);
          return [...items];
        });
      } else if (isContactWithTransaction) showError(`Absolete Contacts Can't Have Transactions`);
      setCheckedCardsIds(checkedCardsIds);
    },
    [checkedCardsIds, setCheckedCards, setCheckedCardsIds]
  );
  const focusedRowChanged = useCallback(
    (rowIndex, item) => {

      if (rowIndex !== -1 && onRowClick) onRowClick(item, rowIndex);
      const currentActiveActions = defaultPrefernces;

      if (item && !item.isDiscardContact) {
        currentActiveActions.push({
          enum: TableActions.discardDuplicateText.key,
          isDisabled: false,
          externalComponent: null,
        })
      } else if (item && item.isDiscardContact) {
        currentActiveActions.push({
          enum: TableActions.removeDiscardText.key,
          isDisabled: false,
          externalComponent: null,
        })
      }


      setActiveprefernces(currentActiveActions);
    },
    [defaultPrefernces, onRowClick]
  );

  const getUniqueFields = (fields) => {
    return fields.filter(e => (e.formFieldName !== 'nationality' 
    && e.formFieldName !== 'email_address'))
  }
  
  const getAllFormFieldsByFormId = useCallback(async () => {
    setIsLoading(true);
    Promise.all([
      await GetAllFormFieldsByFormId(FormsIdsEnum.contactsIndividual.id),
      await GetAllFormFieldsByFormId(FormsIdsEnum.contactsCorporate.id),
    ])
      .then((result) => {
        if (Array.isArray(result[0]) && Array.isArray(result[1])) {
          const concantinateFields = result[0]
            .concat(result[1])
            .filter(
              (field, index, array) =>
                array.findIndex((element) => element.formFieldKey === field.formFieldKey) === index
            );
          const fieldsList = getUniqueFields(concantinateFields);
          setAllFormFields(fieldsList);
        } else setAllFormFields([]);
        setIsLoading(false);
      })
      .catch(() => {
        setAllFormFields([]);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (isDiscardChanged) reloadData()
  }, [isDiscardChanged]);

  const createDiscardContact = useCallback(async (discardContactId) => {
    setIsLoading(true);

    const contactId = +GetParams('id');
    const res = await DiscardContact({ contactId, discardContactId });

    if (!(res && res.status && res.status !== 200)) {
      showSuccess(t('Shared:duplicate-discareded-successfully'));
    } else {
      showError(t('Shared:duplicate-discareding-failed'));
    }
    setIsLoading(false);

  })
  const removeDiscardContact = useCallback(async (discardContactId) => {
    setIsLoading(true);
    const contactId = +GetParams('id');
    const res = await RemoveDiscardContact({ contactId, discardContactId });

    if (!(res && res.status && res.status !== 200)) {
      showSuccess(t('Shared:discard-removed-successfully'));
    } else {
      showError(t('Shared:removing-discard-failed'));
    }
    setIsLoading(false);

  })
  useEffect(() => {
    getAllFormFieldsByFormId();
  }, [getAllFormFieldsByFormId]);
  useEffect(() => {
    if (
      tableColumnsFilterResponse &&
      tableColumnsFilterResponse[ColumnsFilterPagesEnum.contacts.key]
    ) {
      setSelectedTableFilterColumns(
        tableColumnsFilterResponse[ColumnsFilterPagesEnum.contacts.key]
      );
    }
  }, [tableColumnsFilterResponse]);
  
  useEffect(() => {
    setTableColumns([
      ...DuplicateContactsTableHeaderData.filter(
        (item) => selectedTableFilterColumns.findIndex((element) => element === item.id) !== -1
      ),
      ...allFormFields
        .filter(
          (item) =>
            selectedTableFilterColumns.findIndex((element) => element === item.formFieldId) !== -1
        )
        .map((field) => ({
          id: field.formFieldId || null,
          key: field.formFieldKey || null,
          isDate: field.uiWidgetType === 'alt-date' || false,
          label: (field.formFieldTitle && field.formFieldTitle.replace('*', '')) || '',
          input: field.displayPath || '',
        })),
    ]);
  }, [allFormFields, selectedTableFilterColumns]);

  useEffect(() => {
    setTableFilterData(
      tableColumns.map((column) => ({
        key: column.key || column.fieldKey || column.id,
        filterType:
          (column.isDate && TableFilterTypesEnum.datePicker.key) ||
          TableFilterTypesEnum.textInput.key,
        isHiddenFilter: column.isHiddenFilter,
        isHidden: column.isHidden,
        textInputType: column.textInputType,
        textInputMax: column.textInputMax,
        textInputMin: column.textInputMin,
        displayPath:
          (column.key && column.input) ||
          (column.fieldKey &&
            allFormFields &&
            allFormFields.findIndex((item) => item.formFieldKey === column.fieldKey) !== -1 &&
            allFormFields.find((item) => item.formFieldKey === column.fieldKey).displayPath) ||
          undefined,
      }))
    );
  }, [allFormFields, tableColumns]);

  return (
    <div className='w-100 px-3'>
      <TableColumnsFilterComponent
        columns={DuplicateContactsTableHeaderData.filter(item => !item.isHidden ).concat(
          allFormFields.filter(
            (item) =>
              DuplicateContactsTableHeaderData.findIndex(
                (element) => element.fieldKey === item.formFieldKey
              ) === -1
          )
        ).map((item) => ({
          key: item.formFieldId || item.id,
          value: (item.formFieldTitle && item.formFieldTitle.replace('*', '')) || item.label,
        }))}
        isLoading={isLoading}
        selectedColumns={selectedTableFilterColumns}
        onSelectedColumnsChanged={(newValue) => {
          setSelectedTableFilterColumns(newValue);
          let localTableColumnsFilterResponse = tableColumnsFilterResponse;
          if (localTableColumnsFilterResponse)
            localTableColumnsFilterResponse[ColumnsFilterPagesEnum.contacts.key] = newValue;
          else {
            localTableColumnsFilterResponse = {
              [ColumnsFilterPagesEnum.contacts.key]: newValue,
            };
          }
          dispatch(
            TableColumnsFilterActions.TableColumnsFilterRequest(localTableColumnsFilterResponse)
          );
        }}
        parentTranslationPath={parentTranslationPath}
        translationPath=''
      />
      <Tables
        isWithCheckboxColumn={isWithCheckboxColumn}
        data={detailsContactsList.result}
        HideSellectAll
        TotalSelect={(checkedCardsIds&&checkedCardsIds.length -1 || 0 ) }
        selectAllOptions={
          (activeSelectedAction === 'merge' && {
            selectedRows: checkedCardsIds,
            getIsSelected,
            disabledRows: [],
            getIsDisabled,
            onSelectClicked,
          }) ||
          undefined
        }
        headerData={tableColumns}
        defaultActions={activePrefernces}
        onPageIndexChanged={onPageIndexChanged}
        onPageSizeChanged={onPageSizeChanged}
        actionsOptions={{
          onActionClicked: tableActionClicked,
        }}
        itemsPerPage={filter.pageSize}
        activePage={filter.pageIndex}
        parentTranslationPath={parentTranslationPath}
        focusedRowChanged={focusedRowChanged}
        totalItems={detailsContactsList ? detailsContactsList.totalCount : 0}
        filterValues={contactTableFilter}
        onFilterValuesChanged={onFilterValuesChanged}
        filterData={tableFilterData}
        externalPopoverComponent={(
          <ButtonBase
            className={TableActions.whatsappSolid.buttonClasses}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
            }}
          >
            <span className={TableActions.whatsappSolid.icon} />
          </ButtonBase>
        )}
      />
      <ContactsActionDialogsComponent
        isOpen={isOpenContactsActionDialog}
        isOpenChanged={() => setisOpenContactsActionDialog(false)}
        actionEnum={detailedCardAction.actionEnum}
        item={detailedCardAction.item}
        translationPath=''
        parentTranslationPath='ContactsView'
      />
    </div>
  );
};

DuplicateContactsTableComponent.propTypes = {
  onRowClick: PropTypes.func,
  isWithCheckboxColumn: PropTypes.bool,
  isOneSelect: PropTypes.bool,
  pathName: PropTypes.string.isRequired,
  setCheckedCards: PropTypes.func.isRequired,
  onPageSizeChanged: PropTypes.func.isRequired,
  setCheckedCardsIds: PropTypes.func.isRequired,
  onPageIndexChanged: PropTypes.func.isRequired,
  onFilterValuesChanged: PropTypes.func.isRequired,
  filter: PropTypes.instanceOf(Object).isRequired,
  parentTranslationPath: PropTypes.string.isRequired,
  translationPath: PropTypes.string.isRequired,
  checkedCards: PropTypes.instanceOf(Object).isRequired,
  checkedCardsIds: PropTypes.instanceOf(Object).isRequired,
  detailsContactsList: PropTypes.instanceOf(Object).isRequired,
  activeSelectedAction: PropTypes.instanceOf(Object).isRequired,
  contactTableFilter: PropTypes.instanceOf(Object),
  setActiveTab: PropTypes.func.isRequired,
};

DuplicateContactsTableComponent.defaultProps = {
  onRowClick: undefined,
  isWithCheckboxColumn: false,
  contactTableFilter: undefined,
  isOneSelect: false,
};
